// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WWH5","buttons":"styles_buttons__spcK5"};